import React from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Title from 'components/_new/typography/deprecated/Title/Title'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import s from './HeroSection.scss'

import birdieImage from './images/birdie.svg'


const HeroSection = ({ email, messages }) => {
  const { isMobile }  = useMedia()
  const basePadding   = isMobile ? '36' : '60'

  return (
    <WidthContainer>
      <Box className={s.container} pt={basePadding} pb={basePadding}>
        <Box mb={isMobile && '24'} alignCenter>
          <img className={s.image} src={birdieImage} alt="" />
        </Box>
        <Box ml={!isMobile && '36'}>
          <Title size="lg" message={messages.title} dataTestId="heroTitle" />
          <Text html message={{ ...messages.email, values: { email } }} dataTestId="heroText" />
        </Box>
      </Box>
    </WidthContainer>
  )
}

HeroSection.propTypes = {
  email: PropTypes.string,
  messages: PropTypes.object,
}


export default HeroSection
